import React from "react";
import { LabelContentDiv } from "./styled";
import { Col, Form } from "react-bootstrap";
import { Skeleton } from 'primereact/skeleton';

interface LabelContentProps {
   loading: boolean;
   label: string;
   value: string;
}
const LabelContentComponent: React.FC<LabelContentProps> = ({
   loading,
   label,
   value,
}) => {
   return (
      <LabelContentDiv>
         <Form.Group className="section-css" controlId={`formName-${label}`}>
            <Form.Label column xs={5}>
               {label}
            </Form.Label>
            <Col xs={7}>
               {loading ? (<Skeleton width="6rem" height="1rem"></Skeleton>)
                  : (<Form.Control
                     className="content-css"
                     plaintext
                     readOnly
                     defaultValue={value}
                  />)}
            </Col>
         </Form.Group>
      </LabelContentDiv>
   );
};

export default LabelContentComponent;
